import i18n from 'modules/core/lib/i18n'

import { IQuestionGroup } from 'modules/surveys/store/models/QuestionGroup'

const isMember = (value: string, keys: string[]): value is IQuestionGroup['state'] =>
  keys.includes(value)

export default function surveysQuestionStatus(list: string[]): string[] {
  const values: Record<IQuestionGroup['state'], string> = {
    active: i18n.t('custom_reports.especial_filters.surveys_question_status.options.active'),
    closed: i18n.t('custom_reports.especial_filters.surveys_question_status.options.closed'),
    completed: i18n.t('custom_reports.especial_filters.surveys_question_status.options.completed'),
    draft: i18n.t('custom_reports.especial_filters.surveys_question_status.options.draft'),
  }

  return list
    .map((value) => (isMember(value, Object.keys(values)) ? values[value] : value))
    .filter((value) => value !== undefined)
}
